import {HttpHeaders} from '@angular/common/http';

export const HttpOptions = {
  headers: new HttpHeaders({
    Accept: 'application/json',
    'Content-type': 'text/plain;charset=UTF-8',
    // versionnumber: environment.globalVersion
  }),
};
